import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const usePreserveQueryParamsNavigate = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  return useCallback(
    // replace: leave no history entry for the page being left (ZLAYT-1646:
    // the letter page opened after Generate should not have Close go back
    // to the create form).
    (to: string, options?: { replace?: boolean }) => {
      navigate({ pathname: to, search }, options);
    },
    [navigate, search]
  );
};
